export function create_project(label, description, img, tasks, id) {
    return { label, description, img, tasks, id };
}